export function setBrandTheme(componentBrand: HTMLDivElement) {
  const currentBrand =
    window.top?.aemNamespace && window.top?.aemNamespace.pageEnvironmentVariables.brand.subBrand;

  if (currentBrand === 'amg') {
    componentBrand.dataset.theme = 'amg';
  } else if (currentBrand === 'maybach') {
    componentBrand.dataset.theme = 'maybach';
  }
}
